import {createContext} from "react";

export const audioDataContext = createContext(null)
export const contentDataContext = createContext(null)
export const layoutContext = createContext(null)
export const userContext = createContext(null)
export const apiContext = createContext(null)